module.exports = __webpack_public_path__ + "media/images/volver-578d8689b4237ee954ee676be68386e4.png";